export type Visibility = 'PUBLIC' | 'PRIVATE';
export const Visibility = {
  PUBLIC: 'PUBLIC' as Visibility,
  PRIVATE: 'PRIVATE' as Visibility,
};
